
import Vue from 'vue'

export default Vue.extend({
  name: 'BlogSinglePost',
  data() {
    return {
      shareIconColor: 'primary',
    }
  },
  computed: {
    wpPost() {
      return this.$store.state.wp.selectedPost
    },
    postUrl() {
      return `${this.$config.nuxtBaseURL}/articles/${this.$store.state.wp.selectedPost.slug}`
    },
    wpBaseUrl() {
      return this.$config.wpBaseURL
    },
    nuxtBaseURL() {
      return this.$config.nuxtBaseURL
    },
  },
})
